import * as React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import EnrollmentValidationDebugFilterEvaluation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentValidationDebugFilterEvaluation';
import ListEvaluationTable from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/enrollmentChecks/ListEvaluationTable';
import UILink from 'UIComponents/link/UILink';
import { getEnrollmentHistoryGogglesUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentCheckValidationResultExplanation = ({
  validationResult,
  flowRevision,
  objectId
}) => {
  switch (validationResult.validationType) {
    case 'ENROLLMENT_LIST_EVALUATION':
      {
        return /*#__PURE__*/_jsx(EnrollmentValidationDebugFilterEvaluation, {
          listId: validationResult.listId,
          evaluationResult: validationResult.evaluationResult,
          flowRevision: flowRevision,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.passed' : validationResult.listId ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.doesNotMeetCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.noEnrollmentList'
          })
        });
      }
    case 'REFINEMENT_LIST_EVALUATION':
      {
        const refinementList = flowRevision.flow.associatedLists.find(list => list.listTypes.includes('REFINE_BY_LIST'));
        return /*#__PURE__*/_jsx(EnrollmentValidationDebugFilterEvaluation, {
          listId: refinementList && refinementList.listId,
          evaluationResult: validationResult.evaluationResult,
          flowRevision: flowRevision,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? refinementList ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.REFINEMENT_LIST_EVALUATION.description.passed.metRefinementCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.REFINEMENT_LIST_EVALUATION.description.passed.noRefinementCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.REFINEMENT_LIST_EVALUATION.description.failed'
          })
        });
      }
    case 'CLASSIC_GOAL_LIST_EVALUATION':
      {
        return /*#__PURE__*/_jsx(EnrollmentValidationDebugFilterEvaluation, {
          listId: validationResult.listId,
          evaluationResult: validationResult.evaluationResult,
          flowRevision: flowRevision,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? validationResult.listId ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_GOAL_LIST_EVALUATION.description.passed.doesNotMeetCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_GOAL_LIST_EVALUATION.description.passed.noGoalCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_GOAL_LIST_EVALUATION.description.failed'
          })
        });
      }
    case 'SUPPRESSION_REMOVE_LIST_EVALUATION':
      {
        return /*#__PURE__*/_jsx(EnrollmentValidationDebugFilterEvaluation, {
          listId: validationResult.listId,
          evaluationResult: validationResult.evaluationResult,
          flowRevision: flowRevision,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? validationResult.listId ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_REMOVE_LIST_EVALUATION.description.passed.notMet' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_REMOVE_LIST_EVALUATION.description.passed.notEnabled' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_REMOVE_LIST_EVALUATION.description.failed'
          })
        });
      }
    case 'SUPPRESSION_LIST_EVALUATION':
      {
        if (Object.keys(validationResult.evaluationResultsByListId).length === 0) {
          return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.description.passed"
          });
        }
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.description.passed' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.description.failed'
          }), /*#__PURE__*/_jsx(ListEvaluationTable, {
            flowRevision: flowRevision,
            evaluationResultsByListId: validationResult.evaluationResultsByListId
          })]
        });
      }
    case 'OBJECT_PREVIOUSLY_ENROLLED':
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? validationResult.shouldReEnroll ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.OBJECT_PREVIOUSLY_ENROLLED.description.passed.hasReEnrollment' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.OBJECT_PREVIOUSLY_ENROLLED.description.passed.notEnrolled' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.OBJECT_PREVIOUSLY_ENROLLED.description.failed'
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: getEnrollmentHistoryGogglesUrl({
              portalId: flowRevision.portalId,
              flowId: flowRevision.flowId,
              objectTypeId: flowRevision.flow.objectTypeId,
              objectId
            }),
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.OBJECT_PREVIOUSLY_ENROLLED.description.enrollmentGogglesLink"
            })
          })]
        });
      }
    case 'FLOW_ENROLLMENT_MERGE_ALLOWED':
      {
        if (flowRevision.flow.isClassicWorkflow) {
          if (flowRevision.flow.classicEnrollmentSettings.allowEnrollmentFromMerge) {
            return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.FLOW_ENROLLMENT_MERGE_ALLOWED.description.passed.fromMerge"
            });
          }
          return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.FLOW_ENROLLMENT_MERGE_ALLOWED.description.passed.noMerge' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.FLOW_ENROLLMENT_MERGE_ALLOWED.description.failed.contactFlow'
          });
        }
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.FLOW_ENROLLMENT_MERGE_ALLOWED.description.passed.noMerge' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.FLOW_ENROLLMENT_MERGE_ALLOWED.description.failed.nonContactFlow'
        });
      }
    default:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: validationResult.enrollmentAllowed ? `flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.${validationResult.validationType}.description.passed` : `flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.${validationResult.validationType}.description.failed`
      });
  }
};
export default EnrollmentCheckValidationResultExplanation;